import { api, unwrap } from "./httpClient";
import type { AuthSuccessPayload, RefreshPayload, User } from "../types/api";

/**
 * Auth Service
 * Chaque fonction renvoie la structure { user, tokens } pour alimenter le contexte d'authentification.
 */
export const register = (payload: {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  password: string;
}) =>
  unwrap<AuthSuccessPayload>(
    api({ method: "POST", url: "/auth/register", data: payload })
  );

export const login = (payload: { email: string; password: string }) =>
  unwrap<AuthSuccessPayload>(
    api({ method: "POST", url: "/auth/login", data: payload })
  );

export const refresh = (payload: RefreshPayload) =>
  unwrap<AuthSuccessPayload>(
    api({ method: "POST", url: "/auth/refresh", data: payload })
  );

export const logout = (payload: RefreshPayload) =>
  api({ method: "POST", url: "/auth/logout", data: payload });

export const me = () => unwrap<User>(api({ method: "GET", url: "/auth/me" }));

export const confirmAccount = (payload: { token: string }) =>
  unwrap<User>(api({ method: "POST", url: "/auth/confirm", data: payload }));

export const resendConfirmation = (payload: { email: string }) =>
  unwrap<{ ok: boolean }>(
    api({ method: "POST", url: "/auth/resend-confirmation", data: payload })
  );

export const loginWithGoogle = (payload: { credential: string }) =>
  unwrap<AuthSuccessPayload>(
    api({ method: "POST", url: "/auth/google", data: payload })
  );

export const forgotPassword = (payload: { email: string }) =>
  unwrap<{ ok: boolean }>(
    api({ method: "POST", url: "/auth/forgot-password", data: payload })
  );

export const resetPassword = (payload: { token: string; password: string }) =>
  unwrap<{ ok: boolean }>(
    api({ method: "POST", url: "/auth/reset-password", data: payload })
  );
